import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUpload } from './file-upload';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {
  fileName: string = '';
  accept: string = '';
  selectionValid = false;
  error: string = null;
  constructor(public dialogRef: MatDialogRef<FileUploadDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: FileUpload) {
    this.accept = this.data.accept.join(', ');
  }

  ngOnInit(): void {
  }

  onSelectedFileChange(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
    }
    this.validateFileSection(event.target.files);
  }

  validateFileSection(files: File[]): void {
    this.error = null;
     const fileArr = Array.from(files);
     fileArr.forEach(file => {
      const split = file.name?.split('.');
      const ext = '.' + (split[split.length - 1]);
      if (this.data.accept.find(ac => ac.toLowerCase() == ext.toLowerCase()) !== undefined) {
        this.selectionValid = true;
      } else {
        this.error = "Please select file with accepted format!";
        this.selectionValid = false;
      }
     });
  }
}
